import React from 'react';

const summary = () => {
    return (
        <div  style={{
            width:'600px',
            height:'400px',}} >
            <div className='container'>
                <h5>Summary</h5>
                <div className='row'>
                    
                </div>
            </div>
        </div>
    )
}
export default summary;